import {GeoPortaleConfig} from '../../../app/config/model/geoportale-config.model'

export const GEO_PORTAL_CONFIG: GeoPortaleConfig = {
  geoPortale: [
    {
      label: "National",
      url: "maps.geo.admin.ch"
    },
    {
      label: "Kantonal",
      url: "kkgeo.ch/geodatenangebot/kantonale-geoportale.html"
    }
  ]
};
